import advRegister from '@/components/sign-log/advertising-register/register.js';
const COOKIE_AUTHORITY_KEY = 'COOKIE_AUTHORITY_QUERY';
const themeMap = {
    standard: () =>
        import(
            /* webpackChunkName: "common/cookie-authority/standard" */ './theme/standard.vue'
        )
};

/**
 *  condition : 1.  not logged in  2.  not asked  3.  No AD
 */
function init(Vue, store) {
    const iscms = window.sitePageAutoInit === false;
    const isCmsListing = window.location.href.includes('/listing-for-cms');
    //  Exclude Ad Pages   and  cms
    const isAd = /x_ads_source/.test(location.search);
    const globalData = store.state.page.page;
    if (isAd || iscms || isCmsListing) {
        return;
    }
    if (
        globalData._disableCookieAuthority ||
        (advRegister.isShow(globalData) && globalData.isLandingPage)
    ) {
        return;
    }

    let cookieAuthority = null;
    let hasQerried = localStorage.getItem(COOKIE_AUTHORITY_KEY);
    const isSitePrivacy = location.href.includes(
        '/site/privacy-terms#privacy-policy'
    );

    if (hasQerried == '0' && !isSitePrivacy) {
        hasQerried = '';
        localStorage.removeItem(COOKIE_AUTHORITY_KEY);
    }
    store
        .dispatch('getUser', {
            checkOtherIframe: true,
            fromGlobal: true
        })
        .then(isLogin => {
            const { template } = globalData || {};
            if (
                !isLogin &&
                (!hasQerried || (hasQerried == '0' && isSitePrivacy))
            ) {
                const compFn = themeMap[template] || themeMap['standard'];
                compFn()
                    .then(comp => comp.default)
                    .then(compConfig => {
                        cookieAuthority = new Vue(compConfig).$mount();
                        //  mount 
                        document.body.appendChild(cookieAuthority.$el);
                        cookieAuthority.$on('hidden', () => {
                            localStorage.setItem(COOKIE_AUTHORITY_KEY, '1');
                            //  Remove after animation 
                            setTimeout(() => {
                                if (cookieAuthority) {
                                    cookieAuthority.$destroy();
                                    cookieAuthority = null;
                                }
                            }, 1000);
                        });
                        if (hasQerried == '0') {
                            cookieAuthority.setVisible(true);
                        } else {
                            setTimeout(() => {
                                localStorage.setItem(COOKIE_AUTHORITY_KEY, '0');
                                cookieAuthority.setVisible(true);
                            }, 5000);
                        }
                    });
            }
        });

    //  Listen for user logins ,  The user has not closed the pop-up box and needs to close it after logging in 
    siteAppVm.$EventBus.$on('userLogin', user => {
        if (
            cookieAuthority &&
            localStorage.getItem(COOKIE_AUTHORITY_KEY) != '1'
        ) {
            cookieAuthority.setVisible(false);
            localStorage.removeItem(COOKIE_AUTHORITY_KEY);
            setTimeout(() => {
                cookieAuthority.$destroy();
                cookieAuthority = null;
            }, 1000);
        }
    });
}

export default init;
